export default {
  title: 'Nastavení účtu',
  subtitle: 'Spravujte své osobní údaje a bezpečnostní předvolby',

  nav: {
    sections: {
      personal: 'Osobní údaje',
      password: 'Heslo',
      kyc: 'Zabezpečení a ověření totožnosti',
      email: 'Předvolby e-mailu',
    },
    signOut: 'Odhlásit se',
  },

  personal: {
    description: 'Vaše jméno, adresa a telefon. Potřebné pro nákup i dobití peněženky.',
    title: 'Osobní údaje',
    completeProfileTitle: 'Před prvním nákupem vyplňte svůj profil',
    completeProfileMissing: 'Ještě chybí:',
    fields: {
      firstName: 'Jméno',
      lastName: 'Příjmení',
      emailAddress: 'E-mailová adresa',
      country: 'Země',
      dateOfBirth: 'Datum narození',
      address: 'Adresa',
      addressPlaceholder: 'Ulice, číslo domu, byt',
      city: 'Město',
      postalCode: 'PSČ',
      phone: 'Telefon',
      phoneCountryCode: 'Telefonní předvolba země',
    },
    badges: {
      verified: 'Ověřeno',
      unverified: 'Neověřeno',
    },
    save: 'Uložit změny',
    savedOk: 'Uloženo.',
    saveError: 'Profil se nepodařilo uložit.',
  },

  password: {
    description: 'Použijte silné heslo, které nikde jinde nepoužíváte.',
    title: 'Změnit heslo',
    currentPassword: 'Současné heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrdit nové heslo',
    hint: 'Minimálně 8 znaků, musí obsahovat písmeno a číslici.',
    strength: {
      weak: 'Slabé',
      ok: 'Přijatelné',
      strong: 'Silné',
    },
    update: 'Aktualizovat heslo',
    updating: 'Aktualizace…',
    updatedOk: 'Heslo bylo aktualizováno. Ostatní relace byly odhlášeny.',
    updateError: 'Heslo se nepodařilo změnit.',
    errorTooShort: 'Nové heslo musí mít alespoň 8 znaků a obsahovat písmeno a číslici.',
    errorMismatch: 'Nové heslo a potvrzení se neshodují.',
  },

  kyc: {
    description: 'Ověření totožnosti pro větší nákupy.',
    title: 'Ověření totožnosti',
    statusApproved: 'Totožnost ověřena',
    statusPending: 'Ověření probíhá',
    statusNone: 'Ověření nezahájeno',
    approvedOn: 'Schváleno dne {date}',
    pendingNote: 'E-mailem vás informujeme o výsledku.',
    noneNote: 'Vyžadováno pro nákupy nad 50 €. Trvá méně než 5 minut.',
    warning: 'Důležité: Před odesláním se ujistěte, že osobní údaje v účtu (jméno, adresa, datum narození) odpovídají údajům na vašich dokladech.',
    dropHint: 'Přetáhněte soubor sem nebo klikněte pro výběr · PDF, JPG, PNG',
    dropActive: 'Pusťte soubor pro přiložení',
    idProofLabel: 'Doklad totožnosti (přední a zadní strana, max. 2 soubory)',
    addressProofLabel: 'Doklad o adrese (vyúčtování energií, výpis z účtu)',
    submit: 'Odeslat ověření totožnosti',
    submitting: 'Odesílání...',
    reReview: 'Požádat o nové posouzení',
    reviewRequested: 'Žádost odeslána',
    successMessage: 'Žádost o ověření totožnosti odeslána. Dokumenty jsou předány k posouzení.',
    errorNoId: 'Nahrajte prosím alespoň jeden soubor s dokladem totožnosti.',
    errorNoAddress: 'Nahrajte prosím soubor s dokladem o adrese.',
    errorGeneric: 'O ověření totožnosti se nepodařilo požádat.',
  },

  emailPrefs: {
    description: 'Co vám posíláme do schránky.',
    title: 'Předvolby e-mailu',
    body: 'Předvolby e-mailu zatím nelze konfigurovat. Transakční e-maily (potvrzení objednávky, doručení klíče, obnovení hesla) jsou vždy odesílány. Marketingové e-maily nezasíláme.',
    unsubscribe: 'Chcete-li se zcela odhlásit, kontaktujte',
  },
};
